import
React
  from 'react';

import
PropTypes
  from 'prop-types';

import 'react-input-range/lib/css/index.css';

import {
  SalesContext
} from 'src/Context/SalesContext';

import
CheckedLabel
  from 'src/Components/Common/Svg/CheckedLabel';

import
UncheckedLabel
  from 'src/Components/Common/Svg/UncheckedLabel';

import {
  getPageArray
} from 'src/Utility/utility';

import {
  BackIcon,
  MinusIcon,
  PlusIcon,
  TickGreen,
  RightArrow,
  CallIconWhite
} from 'src/Components/Common';

import
HelpMeChoose
  from '../HelpMeChoose/HelpMeChoose';

import
WithPopup
  from 'src/HOC/WithPopup/WithPopup';

import {
  PackageTypes,
  PackageTypesDisplayNames
} from 'src/Common/constants';

import './Filters.css';

class Filters extends React.Component {
  static contextType = SalesContext;

  state = {
    showFilters: false,
    filters: [],
    openedFilters: ['dealType', 'Show promotions only', 'downloadSpeed'],
    selectedMobileFilter: {},
    hideList: false
  }

  availableDeals = [];

  downloadSpeedStr = '';

  packageTypes = [PackageTypes.StandaloneFibreDeals, PackageTypes.PremiumFibreDeals];

  mobileFiltersContent = [];

  componentDidUpdate = (prevProps) => {

    if (prevProps.dealType !== this.props.dealType) {

      this.resetFilterOptionsOnChange();
    }

    if (prevProps.packages !== this.props.packages) {

      this.setState({
        filters: this.context.filterList
      })
    }

    if (prevProps.showFilters !== this.props.showFilters) {

      this.setState({
        showFilters: this.props.showFilters
      })
    }
  }

  checkForDiscount() {

    let hasDiscount = false;
    for (let index = 0; index < this?.context?.providerPackages?.length; index++) {
      const element = this?.context?.providerPackages[index];
      if (element.onDiscount && element.dealType == this.context.selectedPackageType) {
        hasDiscount = true;
        break;
      }
    }
    return (hasDiscount)
  }

  resetFilterOptionsOnChange = () => {

    this.context.setFilterList([]);
    this.setState({
      filters: []
    })
    this.downloadSpeedStr = '';
    this.updateMobileFilters();
    this.context.setSelectedPageNo(1);
    this.context.setPageNos(getPageArray([this.context?.providerPackages]), () => this.props.determinePackages())
  }

  async checkboxSelect(value) {

    let filterList = this.state.filters;
    if (filterList.includes(value)) {
      let index = filterList.indexOf(value);
      filterList.splice(index, 1);
    }
    else {
      filterList.push(value);
    }
    this.setState({
      filters: filterList
    })

    await this.context.setFilterList(this.state.filters);
    await this.context.setSelectedPageNo(1);
    this.context.setPageNos(getPageArray([this.context?.providerPackages]), () => this.props.determinePackages())
  }

  openFilter(filter) {

    let openedFiltersList = this.state.openedFilters;
    if (openedFiltersList.includes(filter)) {
      let index = openedFiltersList.indexOf(filter);
      openedFiltersList.splice(index, 1);
    }
    else {
      openedFiltersList.push(filter);
    }
    this.setState({
      openedFilters: openedFiltersList
    })
  }

  async updatePackageType(packageType) {

    await this.context.setSelectedPackageType(packageType);
    this.resetFilterOptionsOnChange();
  }


  updateMobileFilters() {

    let content = [];
    content.push(
      {
        key: 'dealType',
        heading: 'Fibre deals',
        subtext: PackageTypesDisplayNames[this.context.selectedPackageType]
      }
    )

    if (this.checkForDiscount) {
      content.push(
        {
          key: 'Show promotions only',
          heading: 'Promotions',
          subtext: this.state.filters.includes('Show promotions only') ? 'Show promotions only' : ''
        },
        {
          key: 'downloadSpeed',
          heading: 'Download speed',
          subtext: this.downloadSpeedStr
        }
      )
    }

    this.mobileFiltersContent = content;
  }

  openMobileFilter(type) {

    let content = {};

    if (type === 'dealType') {
      content = {
        content: this.props.availableDeals?.filter(element => this.packageTypes.includes(element)),
        type: 'radio',
        key: type
      }
    }
    else if (type === 'Show promotions only') {
      content = {
        content: ['Show promotions only'],
        type: 'checkbox',
        key: type
      }
    }
    else if (type === 'downloadSpeed') {
      content = {
        content: this.props.downloadSpeedArr,
        type: 'checkbox',
        key: type
      }
    }
    this.setState({
      selectedMobileFilter: content,
      hideList: true
    })
  }

  componentDidMount() {
    this.updateMobileFilters();
  }

  filterBackMobile = () => {

    if (this.state.hideList) {
      this.setState({
        hideList: false
      })
    }
    else {
      this.props.toggleFilter()
    }
  }

  mobileFilterSelect(item, type) {

    if (type === 'dealType') {
      this.updatePackageType(item)
    }
    else {
      this.checkboxSelect(item);
    }
    if (type === 'downloadSpeed') {
      this.downloadSpeedStr = '';
      this.state.filters.map((item, index) => {
        if (item !== 'Show promotions only') {
          this.downloadSpeedStr += item;
          this.downloadSpeedStr += index !== this.state.filters.length - 1 ? ', ' : '';
        }
      })
    }
    this.updateMobileFilters();
  }

  applyFilter = () => {
    
    this.setState({
      hideList: false
    })
    this.props.toggleFilter();
  }

  showCallMeBack = () => {
    this.context.setShowCallMeBack(true);
  }

  render() {

    const contentStyleMobile = {
      position: 'absolute',
      margin: 'auto',
      top: '0',
      width: '100%',
      height: '100vh',
      background: 'white'
    }

    return (
      <div>

        <div className="filters-wrapper">

          <hr className='filters-hr' />

          <div className='filters-section'>

            <div className='filters-name-wrapper' onClick={() => this.openFilter('dealType')}>

              <div className='filters-name'>
                Deal type
              </div>
              <div>

                { this.state.openedFilters.includes('dealType')

                  ? <MinusIcon />

                  : <PlusIcon />
                }
              </div>
            </div>

            { this.state.openedFilters.includes('dealType')

              ? <div className='filter-wrapper'>

                { this.props?.availableDeals?.map((item, index) => {

                  if (this.packageTypes.includes(item))

                    return (
                      <div
                        key={index}
                        className='filter-label-wrapper'>

                        <label className="filters-radio-button">

                          <input
                            type="radio"
                            value={item}
                            name={item}
                            checked={this.context.selectedPackageType === item}
                            className="filters-radio-button-item"
                            onClick={() => this.updatePackageType(item)} />

                          <span className='radio-indicator' />

                          {PackageTypesDisplayNames[item]}
                        </label>
                      </div>
                    )
                })
                }
              </div>

              : null
            }
          </div>

          { this.checkForDiscount()

            ? <div className='filters-section'>

              <hr className='filters-hr' />

              <div className='filters-name-wrapper' onClick={() => this.openFilter('Show promotions only')}>

                <div className='filters-name'>
                  Promotions
                </div>
                <div>

                  { this.state.openedFilters.includes('Show promotions only')

                    ? <MinusIcon />

                    : <PlusIcon />
                  }
                </div>
              </div>

              { this.state.openedFilters.includes('Show promotions only')

                ? <div className='filter-wrapper'>

                  <div className='filter-label-wrapper'>

                    {this.state.filters.includes('Show promotions only')
                      ? <div className="checkbox-label" onClick={() => this.checkboxSelect('Show promotions only')}><CheckedLabel /></div>

                      : <div className="checkbox-label" onClick={() => this.checkboxSelect('Show promotions only')}><UncheckedLabel /></div>
                    }
                    <div className="filter-label">Show promotions only</div>
                  </div>
                </div>

                : null
              }
            </div>
            :
            null
          }

          <hr className='filters-hr' />

          <div className='filters-section'>

            <div className='filters-name-wrapper' onClick={() => this.openFilter('downloadSpeed')}>

              <div className='filters-name'>
                Download speed
              </div>

              <div>
                { this.state.openedFilters.includes('downloadSpeed')

                  ? <MinusIcon/>

                  : <PlusIcon/>
                }
              </div>
            </div>

            { this.state.openedFilters.includes('downloadSpeed')
              ? <div className='filter-wrapper'>

                  { this.props.downloadSpeedArr?.map((item, index) => {

                      return (

                        <div className='filter-label-wrapper' key={index}>

                          { this.state.filters.includes(item)

                            ?  <div className="checkbox-label" onClick={() => this.checkboxSelect(item)}><CheckedLabel /></div>

                            :<div className="checkbox-label" onClick={() => this.checkboxSelect(item)}><UncheckedLabel /></div>
                          }
                          <div className="filter-label">{item}</div>
                        </div>
                      )
                    })
                  }
                </div>

              : null
            }
          </div>

          <hr className='filters-hr' />

          <div
            className='filters-call-me-back'
            onClick={() => { this.showCallMeBack() }}>

            <div className='filters-call-me-back-icon'>
              <CallIconWhite />
            </div>

            Call me back
          </div>

          <div className='filters-how-it-works'>
            <HelpMeChoose determinePackages={() => this.props.determinePackages()} />
          </div>
        </div>

        { this.state.showFilters &&

          <WithPopup contentStyle={contentStyleMobile}>

            <div className='filters-mobile-header'>

              <div className='filters-mobile-header-back' onClick={this.filterBackMobile}>
                <BackIcon />
              </div>

              <div className='filters-mobile-header-text'>
                Filter fibre plans
              </div>

              <div className='filters-mobile-header-reset' onClick={() => this.updatePackageType(PackageTypes.StandaloneFibreDeals)}>
                Reset
              </div>
            </div>

            <div className='filters-mobile-list'>

              { !this.state.hideList

                ? this.mobileFiltersContent.map((item, index) => {

                    return (
                      <div className={`filters-mobile-list-filter ${item.subtext && 'filters-mobile-list-filter-selected'}`}
                        key={index}
                        onClick={() => this.openMobileFilter(item.key)}>

                        <div className='filters-mobile-list-filter-details'>

                          <div className='filters-mobile-list-filter-heading'>
                            {item.heading}
                          </div>

                          { item.subtext &&

                            <div className='filters-mobile-list-filter-subtext'>
                              {item.subtext}
                            </div>
                          }
                        </div>

                        <div className='filters-mobile-list-filter-icon'>

                          { item.subtext
                            ? <TickGreen />

                            : <RightArrow />
                          }
                        </div>
                      </div>
                    )
                  })

                : this.state.selectedMobileFilter?.content?.map((item, index) => {

                    return (

                      <div
                        className={`filters-mobile-list-filter ${this.state.filters.includes(item)
                          || item === this.context.selectedPackageType ? 'filters-mobile-list-filter-selected' : ''}`}
                        key={index}
                        onClick={() => this.mobileFilterSelect(item, this.state.selectedMobileFilter.key)}>

                        <div className='filters-mobile-list-filter-details'>

                          <div className={this.state.filters.includes(item) || item === this.context.selectedPackageType
                            ? 'filters-mobile-list-filter-heading' : ''}>

                            {this.state.selectedMobileFilter.key === 'dealType' ? PackageTypesDisplayNames[item] : item}
                          </div>
                        </div>

                        <div className='filters-mobile-list-filter-icon'>

                          { this.state.filters.includes(item) || item === this.context.selectedPackageType
                            ? <TickGreen />

                            : null
                          }
                        </div>
                      </div>
                    )
                  })
              }
            </div>
            <div className='filters-mobile-footer'>

              <div className='filters-mobile-footer-button' onClick={this.applyFilter}>
                Apply filters
              </div>
            </div>
          </WithPopup>
        }
      </div>
    )
  }
}

Filters.propTypes = {
  dealType: PropTypes.string,
  determinePackages: PropTypes.func,
  downloadSpeedArr: PropTypes.array
};

export default Filters;